import React, { createContext, useContext, useState, useRef, useEffect } from 'react';

const ResponsiveDialogContext = createContext({ containerWidth: 0 });

export const ResponsiveDialogProvider = ({ children }) => {
    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(0);

    useEffect(() => {
        const observer = new ResizeObserver(entries => {
            if (entries[0]) {
                setContainerWidth(entries[0].contentRect.width);
            }
        });

        const currentRef = containerRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    return (
        <ResponsiveDialogContext.Provider value={{ containerWidth }}>
            <div ref={containerRef} style={{ width: '100%', height: '100%' }}>
                {children}
            </div>
        </ResponsiveDialogContext.Provider>
    );
};

export const useResponsiveDialog = () => useContext(ResponsiveDialogContext);
